// Cost-replacement math block — audit D1.2 / D1.6.
// Verbatim copy from the HeyCatch action-plan "Bring the cost-replacement
// math to the homepage" item. The exact numbers are owned by the /modules
// page already; we surface them above the fold on the homepage so the
// strongest persuasive number is not buried.

import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CostReplacement() {
  return (
    <section
      className="zy-section"
      aria-labelledby="cost-replacement-title"
      data-testid="cost-replacement"
      style={{ paddingTop: 72, paddingBottom: 72, background: "#FAFAFB" }}
    >
      <div className="max-w-5xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10 items-stretch">
          <div className="rounded-2xl bg-white border border-[#eef1f7] p-7">
            <p className="text-[12px] font-bold uppercase tracking-[0.14em] text-[#0A1628]/60">
              Today
            </p>
            <p className="mt-3 text-[32px] font-bold tracking-tight text-[#0A1628] leading-none">
              €1,190
              <span className="text-[14px] font-medium text-[#0A1628]/60 ml-1">
                /month
              </span>
            </p>
            <p className="mt-3 text-[14.5px] text-[#0A1628]/70 leading-relaxed">
              Replace around €1,190 per month in separate professional
              software — CRM, finance, projects, marketing, HR and the
              rest.
            </p>
          </div>

          <div className="rounded-2xl p-7 bg-[#0A1628] text-white border border-[#0A1628] shadow-[0_18px_44px_-18px_rgba(10,22,40,0.45)]">
            <p className="text-[12px] font-bold uppercase tracking-[0.14em] text-white/70">
              With Zynthoro
            </p>
            <p className="mt-3 text-[32px] font-bold tracking-tight leading-none">
              €499
              <span className="text-[14px] font-medium text-white/70 ml-1">
                /month
              </span>
            </p>
            <p className="mt-3 text-[14.5px] text-white/80 leading-relaxed">
              One platform from €499 per month. Four AI specialists built
              in. No more juggling.
            </p>
            <Link
              to="/pricing#subscriptions"
              data-testid="cost-replacement-cta"
              className="mt-5 inline-flex items-center gap-2 rounded-lg bg-[#D4AF37] px-4 py-2.5 text-[13.5px] font-semibold text-[#0A1628] transition-opacity hover:opacity-90"
            >
              See the Starter plan
              <ArrowRight size={14} />
            </Link>
          </div>

          <div className="rounded-2xl bg-white border border-[#eef1f7] p-7">
            <p className="text-[12px] font-bold uppercase tracking-[0.14em] text-[#202B60]">
              You save
            </p>
            <h2
              id="cost-replacement-title"
              className="mt-3 text-[32px] font-bold tracking-tight text-[#202B60] leading-none"
            >
              €691
              <span className="text-[14px] font-medium text-[#0A1628]/60 ml-1">
                every month
              </span>
            </h2>
            <p className="mt-3 text-[14.5px] text-[#0A1628]/70 leading-relaxed">
              Save around €691 every month — on licences you were already
              paying for. Numbers are typical for a 5-50 person SME; your
              own stack will differ.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
